import { useSelectorKiosk } from "./useSelectorKiosk";

const useSettingsState = () => {
    const selector = useSelectorKiosk(state => state.settingsOpened)
    return selector;
}

export default useSettingsState;